import { CreditCardOutlined, ExclamationOutlined, SettingOutlined } from '@ant-design/icons';
import Logout from '@mui/icons-material/Logout';
import StarIcon from '@mui/icons-material/Star';
import { Avatar, Badge, Stack, Typography } from '@mui/material';
import { Avatar as AntAvatar, Dropdown } from 'antd';
import { signOut } from 'next-auth/react';
import Link from 'next/link';
import { useCurrentUser } from '../../hooks/data/user';
import classes from './user-block.module.css';

function UserBlock() {
   const { user, error, isLoading } = useCurrentUser();

   const handleLogout = () => {
      signOut({
         callbackUrl: '/',
      });
   };
   if (isLoading) {
      return <div>Loading...</div>;
   }
   if (!user && !error) {
      return (
         <Avatar sx={{ width: 30, height: 30, cursor: 'pointer', fontSize: 15, bgcolor: 'error.main' }} color="error">
            <ExclamationOutlined color="error" />
         </Avatar>
      );
   }

   const items = [
      {
         label: <Link href={`/account/settings`}>{user.email}</Link>,
         key: 'email',
         icon: (
            <AntAvatar size="small">
               {user.name?.length > 0 ? user.name[0] : user.email?.length > 0 ? user.email[0] : 'U'}
            </AntAvatar>
         ),
      },
      {
         type: 'divider',
      },
      {
         label: <Link href={`/account/settings`}>Settings</Link>,
         key: 'settings',
         icon: <SettingOutlined />,
      },
      {
         label: <Link href={`/account/subscription`}>Subscription</Link>,
         key: 'subscription',
         icon: <CreditCardOutlined />,
      },
      {
         type: 'divider',
      },
      {
         label: 'Logout',
         key: 'logout',
         icon: <Logout fontSize="small" />,
         onClick: () => {
            handleLogout();
         },
      },
   ];

   return (
      <>
         {/* antd menu */}
         <Dropdown
            arrow
            menu={{
               items: items,
            }}
         >
            <div className={classes.userContainer}>
               <div className={classes.info}>
                  <Stack direction="column" spacing={2} alignItems="flex-end">
                     <Typography variant="body" color="text.secondary" fontSize={14} lineHeight={1}>
                        {user.name}
                     </Typography>
                     <Typography variant="body" color="text.secondary" fontSize={10} lineHeight={1}>
                        {user.email}
                     </Typography>
                  </Stack>
               </div>
               <Badge
                  invisible={user.isPremium ? false : true}
                  overlap="circular"
                  color="primary"
                  anchorOrigin={{
                     vertical: 'top',
                     horizontal: 'right',
                  }}
                  sx={{
                     '& .MuiBadge-badge': {
                        border: '1px solid currentColor',
                        padding: 0,
                        width: 16,
                        minWidth: 16,
                        height: 16,
                     },
                  }}
                  badgeContent={<StarIcon color="white" sx={{ fontSize: 10 }} />}
               >
                  <Avatar
                     src={user.avatar}
                     alt={user.name}
                     sx={{ width: 30, height: 30, cursor: 'pointer', fontSize: 15 }}
                  >
                     {user?.name?.length > 0 ? user.name[0] : user?.email?.length > 0 ? user.email[0] : 'U'}
                  </Avatar>
               </Badge>
            </div>
         </Dropdown>
      </>
   );
}
export default UserBlock;
